export default __webpack_public_path__ + "static/media/finance-businessman-success-person-workplace-accounting.36cf191f.webp";